<!-- eslint-disable no-loop-func -->
<!-- eslint-disable no-restricted-syntax -->
<template>
  <Container :class="$style.container">
    <ButtonBack
      text="Dashboard"
      :to="$options.homeRoute"
    />
    <Container
      :class="$style.innerContainer"
      data-test-id="ViewAll__container"
    >
      <div :class="$style.headerStyle">
        <HeadingMedium>
          {{ displayName }} {{ totalCountDisplay }}
        </HeadingMedium>
        <Icon
          v-if="tableData.length"
          :class="iconColor"
          :icon="widgetIcon"
          :scale="1.5"
        />
      </div>
      <ItemListPagination
        :columns="tableColumns"
        :currentPageNum="currentPageNum"
        :indeterminateSelectAll="indeterminateSelectAll"
        :isLoading="isListLoading"
        :itemComponent="$options.RowData"
        :rowsPerPage="rowsPerPage"
        :selectAll="selectAll"
        selectable
        :showEmptyState="!tableData.length"
        :sortBy="sortBy"
        :sortDirection="sortDirection"
        :tableData="tableData"
        :totalCount="totalCount"
        @pageChange="handlePageChange"
        @select="handleSelect"
        @selectAll="handleSelectAll"
        @sortColumn="handleSortColumn"
      >
        <template v-slot:toolbar>
          <HomeSearchBar
            :count="totalCount"
            :disabled="!showActions"
            :dropdownActions="dropdownActions"
            :filterValue="filterValue"
            searchPlaceholder="Search"
            :selectOptions="selectOptions"
            :shouldFocusSearch="shouldFocusSearch"
            :showButtons="showButtons"
            :showFilter="showFilter"
            :toolBarDisplayName="toolBarDisplayName"
            @triggerFilter="filterBy"
            @triggerSearch="handleEnterSearchTerm"
            @triggerSuggestionUpate="handleSuggestionUpdate"
          />
        </template>
      </ItemListPagination>
    </Container>
  </Container>
</template>

<script>
import {
  ButtonBack,
  Container,
  HeadingMedium,
  Icon,
  ItemListPagination,
  Types,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  ItemTypeRoutes,
  StoreModuleMap,
} from 'client/util/Constants';
import { capitalize } from 'lodash';
import { eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapActions, mapGetters, mapState } from 'vuex';
import { notify } from 'client/util';
import DateUtil from 'client/util/DateUtil';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import GroupApi from 'client/api/v2/GroupApi';
import HomeSearchBar from 'client/HomePageV2/components/HomeSearchBar.vue';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';
import InvestigativePageMixin from 'client/HomePageV2/mixins/InvestigativePageMixin';
import RowData from 'client/HomePageV2/components/RowData.vue';
import SystemFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/SystemFilters';
import SystemUserApi from 'client/api/v2/SystemUserApi';
import SystemUserFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/SystemUserFilters';
import UserGroupApi from 'client/api/v2/UserGroupApi';
import ViewAllMixin from 'client/HomePageV2/mixins/ViewAllMixin';

const { Column, DropdownMenuItem } = Types;
const {
  widgetActions,
  widgetNames,
  widgetSortOption,
  widgetTypes,
  widgetTableColumns,
} = HomeWidgetConsts;

const {
  diskEncryption,
  expiredPasswords,
  newUsers,
  userLockouts,
  unencryptedDevices,
  upcomingPasswordExpiration,
} = widgetTypes;

const {
  description,
  displayLogic,
  location,
  section,
  text: textEventProp,
} = eventProperties;

const systemUserCollection = StoreModuleMap[ItemTypeConsts.systemUser];
const suggestedSystemUsersCollection = StoreModuleMap[ItemTypeConsts.suggestedSystemUser];
const administratorModel = 'AdministratorModel';

export default {
  name: 'ViewAll',
  components: {
    ButtonBack,
    Container,
    HeadingMedium,
    HomeSearchBar,
    Icon,
    ItemListPagination,
  },

  homeRoute: ItemTypeRoutes[ItemTypeConsts.home],

  mixins: [InvestigativePageMixin, ViewAllMixin],

  data() {
    return {
      activeTab: 'All',
      counter: 0,
      currentPageNum: 0,
      data: [],
      diskEncryption,
      expiredPasswords,
      filterValue: 'all',
      indeterminateSelectAll: false,
      isListLoading: false,
      newUsers,
      origData: [],
      rowsPerPage: 10,
      selectAll: false,
      selectOptions: [
        { name: 'All', value: 'all' },
        { name: 'Password Pending', value: 'passStatus' },
        { name: 'MFA Enrolled', value: 'mfaEnrolled' },
        { name: 'MFA Not Enrolled', value: 'mfaNotEnrolled' },
      ],
      showActions: false,
      showButtons: false,
      sortBy: 'lastName',
      sortByColumnDirection: 'ascending',
      tableData: [],
      totalCount: 0,
      userLockouts,
      upcomingPasswordExpiration,
      unencryptedDevices,
      widgetName: this.$route.params.widgetName,
      selectedIds: [],
    };
  },

  RowData,
  computed: {
    ...mapGetters(systemUserCollection, ['getDisplayName']),

    ...mapGetters(suggestedSystemUsersCollection, {
      getSelectedSystemUsers: 'getSelectedItems',
      selectedItemsCount: 'getSelectedItemsCount',
    }),

    ...mapState(administratorModel, ['resetKey']),

    displayName() {
      return widgetNames[this.widgetName];
    },

    dropdownActions() {
      let dropdownAction = [];
      const displayAction = !this.showActions;
      switch (this.widgetName) {
        case userLockouts:
          dropdownAction = [
            DropdownMenuItem({
              click: this.handleActionUnlock,
              text: 'Unlock User Account',
              isDisabled: displayAction,
            }),
            DropdownMenuItem({
              click: this.handleActionChangePassword,
              text: 'Force Password Change',
              isDisabled: displayAction,
            }),
            DropdownMenuItem({
              click: this.handleActionSuspend,
              text: 'Suspend Now',
              isDisabled: displayAction,
            }),
          ];
          break;
        case expiredPasswords:
          dropdownAction = [
            DropdownMenuItem({
              click: this.handleEmailResend,
              text: 'Resend Email',
              isDisabled: displayAction,
            }),
          ];
          break;
        case upcomingPasswordExpiration:
        case newUsers:
          dropdownAction = [
            DropdownMenuItem({
              click: this.handleActionChangePassword,
              text: 'Force Password Change',
              isDisabled: displayAction,
            }),
            DropdownMenuItem({
              click: this.handleEmailResend,
              text: 'Resend Email',
              isDisabled: displayAction,
            }),
          ];
          break;
        default:
          break;
      }

      return dropdownAction;
    },

    filters() {
      const filter = [];
      const date = new Date();
      switch (this.widgetName) {
        case userLockouts:
          filter.push(SystemUserFilters.locked(true));
          break;
        case expiredPasswords:
          filter.push(SystemUserFilters.passwordExpired(true));
          break;
        case upcomingPasswordExpiration:
          filter.push(...SystemUserFilters.passwordExpiring(14));
          break;
        case unencryptedDevices:
          filter.push(SystemFilters.fde(false));
          break;
        case newUsers:
          date.setDate(date.getDate() - 7);
          filter.push(SystemUserFilters.created(date));
          break;
        default:
          break;
      }
      return filter;
    },

    iconColor() {
      if (
        HomeWidgetConsts.widgetIcons[this.widgetName] === 'error'
        && !this.totalCount
      ) {
        return this.$style.colorSuccess;
      }
      if (
        HomeWidgetConsts.widgetIcons[this.widgetName] === 'error'
        && this.totalCount
      ) {
        return this.$style.colorWarning;
      }
      return this.$style.colorInfo;
    },

    showFilter() {
      return (
        this.widgetName === 'newUsers'
        || this.widgetName === 'userGroupSuggestions'
      );
    },

    tableColumns() {
      return widgetTableColumns[this.widgetName].map((column) => Column(column));
    },

    widgetIcon() {
      if (
        HomeWidgetConsts.widgetIcons[this.widgetName] === 'error'
        && !this.totalCount
      ) {
        return 'checkmarkCircle';
      }
      return HomeWidgetConsts.widgetIcons[this.widgetName];
    },
  },

  watch: {
    loading(currentValue) {
      this.isListLoading = currentValue;
    },

    resetKey: {
      handler() {
        this.handleCreated();
      },
    },
  },

  created() {
    this.fetchTableData();
  },

  methods: {
    ...mapActions(administratorModel, ['resetActionKey']),

    async fetchAllGroupsData() {
      const apiData = [];
      this.selectAll = false;
      this.showButtons = true;
      const maxLimit = 100;
      this.orgData = [];
      // call the api to get all groups suggestions
      this.sortBy = 'groupname';
      this.sortDirection = 'descending';
      const skip = 0;
      const { data } = await GroupApi.getGroupsWithSuggestions(skip, maxLimit);
      const groupDetails = data;
      if (groupDetails.length > 0) {
        this.selectOptions = [{ name: 'All', value: 'all' }];
        // Add Group Details to the filter drop down
        // eslint-disable-next-line no-restricted-syntax
        for await (const group of groupDetails) {
          const suggestions = await this.fetchAllGroupsSuggestions(group);
          this.selectOptions.push({
            name: group.name,
            value: group.id,
          });
          const userIds = suggestions.map((item) => ({
            _id: item.object.id,
          }));
          const filter = userIds.length ? { or: userIds } : undefined;
          // fetch user information
          const users = await this.fetchUsers(filter, userIds.length);
          // eslint-disable-next-line no-restricted-syntax
          for (const user of users) {
            this.counter += 1;
            const obj = suggestions.find((o) => o.object.id === user.id);
            apiData.push({
              userName: user.username,
              id: this.counter,
              userid: user.id,
              email: user.email,
              href: `#/users/${user.id}/details`,
              lastName: this.getDisplayName(user),
              linklastName: this.getDisplayName(user),
              groupid: group.id,
              groupname: group.name,
              suggestion: capitalize(obj.op),
            });
          }
          this.origData = apiData;
        }
        this.manageDataState(apiData);
      }
      this.isListLoading = false;
    },

    async fetchAllGroupsSuggestions(group) {
      let suggestions;
      const maxLimit = 100;
      const callApi = (page = 0) => UserGroupApi.fetchSuggestions(group.id, {
        params: { skip: page * maxLimit, limit: maxLimit },
      });
      const firstRequest = callApi();
      // recurring api calls if the total count is more than 100
      await firstRequest
        .then((response) => {
          let { totalCount } = response;
          this.totalCount = totalCount;
          if (totalCount > maxLimit) {
            const requests = [firstRequest];
            for (; totalCount > maxLimit; totalCount -= maxLimit) {
              requests.push(callApi(requests.length));
            }
            return Promise.all(requests).then((responses) => responses
              .map((resp) => resp.results)
              .reduce((all, data) => all.concat(data), []));
          }
          return response.results;
        })
        .then((apps) => {
          suggestions = apps;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isListLoading = false;
        });
      return suggestions;
    },

    async fetchSystemUsers() {
      let apiData;
      this.origData = [];
      this.isListLoading = true;
      this.maxFetchLimit = 100;
      const sort = widgetSortOption[this.widgetName];
      const callApi = (page = 0) => SystemUserApi.fetch(
        page * this.maxFetchLimit,
        this.maxFetchLimit,
        sort,
        null,
        null,
        this.filters,
      );
      const firstRequest = callApi();

      await firstRequest
        .then((response) => {
          let { totalCount } = response;
          this.totalCount = totalCount;
          if (totalCount > this.maxFetchLimit) {
            const requests = [firstRequest];
            for (; totalCount > this.maxFetchLimit; totalCount -= this.maxFetchLimit) {
              requests.push(callApi(requests.length));
            }
            return Promise.all(requests).then((responses) => responses
              .map((resp) => resp.results)
              .reduce((all, data) => all.concat(data), []));
          }
          return response.results;
        })
        .then((apps) => {
          apiData = apps;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isListLoading = false;
        });
      this.origData = apiData;
      this.origData = this.origData.map((user) => ({
        userName: user.username,
        id: user.id,
        email: user.email,
        href: `#/users/${user.id}/details`,
        lastName: this.getDisplayName(user),
        linklastName: this.getDisplayName(user),
        state: user.state === 'ACTIVATED' ? 'ACTIVE' : user.state,
        timeStamp: user.account_locked_date
          ? DateUtil.formatDateTime(user.account_locked_date)
          : '',
        passwordExpiredTimeStamp: user.password_expiration_date
          ? DateUtil.formatDateTime(user.password_expiration_date)
          : '',
        mfaStatus: user.mfaEnrollment?.totpStatus,
        passwordStatus: user.activated ? 'Password Active' : 'Password pending',
        actions: widgetActions[this.widgetName],
      }));

      // This condition is added to ensure the state of select is maintained during search
      if (this.data.length > 0) {
        const mergedData = Object.values(
          this.origData.concat(this.data).reduce(
            (r, o) => ({
              ...r,
              [o.id]: o,
            }),
            {},
          ),
        );
        this.data = mergedData;
        this.origData = this.data;
        const obj = this.data.filter((o) => o.selected === true);
        if (obj.length !== this.data.length && this.selectAll) {
          this.selectAll = false;
          this.indeterminateSelectAll = true;
        } else if (obj.length === this.data.length && this.selectAll) {
          this.selectAll = true;
          this.indeterminateSelectAll = false;
        } else if (obj.length === 0) {
          this.selectAll = false;
          this.indeterminateSelectAll = false;
        }
      } else {
        this.data = this.origData;
      }
      this.handleSortColumn();
      let start = this.currentPageNum * this.rowsPerPage;
      let end = start + this.rowsPerPage;
      if (!this.tableData.length) {
        if (this.data.length) {
          start = (this.currentPageNum - 1) * this.rowsPerPage;
          end = start + this.rowsPerPage;
          this.currentPageNum -= 1;
          this.tableData = this.data.slice(start, end);
        } else {
          this.currentPageNum = 0;
        }
      }
    },

    async fetchUsers(filters, userCount) {
      let count = userCount;
      const maxLimit = 100;
      const callUsersApi = async (page = 0) => SystemUserApi.search(filters, '', undefined, page * maxLimit, maxLimit);
      const initialRequest = await callUsersApi();
      let apps = initialRequest.results;

      if (count > maxLimit) {
        const pagedRequests = [];
        for (let i = 1; count > maxLimit; count -= maxLimit, i += 1) {
          pagedRequests.push(callUsersApi(i));
        }

        /* Using Promise.all here is preferred to awaiting in the for loop
         due to a significant performance improvement
        */
        const responses = await Promise.all(pagedRequests);

        /* Initialize with initialRequest.results
          so it is included with the aggregated responses
        */
        apps = responses
          .map((resp) => resp.results)
          .reduce(
            (all, current) => all.concat(current),
            initialRequest.results,
          );
      }
      return apps;
    },

    async filterBy(value) {
      this.currentPageNum = 0;
      let filteringData = [];
      this.filterValue = value;
      this.showActions = false;
      const selectedItems = this.data.map((item) => ({
        ...item,
        selected: false,
      }));
      this.data = selectedItems;
      const tempData = this.origData;
      /** Temporarily commenting this
      await this.fetchTableData();
       */
      filteringData = Object.values(
        tempData.concat(this.data).reduce(
          (r, o) => ({
            ...r,
            [o.id]: o,
          }),
          {},
        ),
      );
      switch (value) {
        case 'all':
          this.filteredByData = filteringData;
          break;
        case 'passStatus':
          this.filteredByData = filteringData.filter(
            (item) => item.passwordStatus === 'Password pending',
          );
          break;
        case 'mfaNotEnrolled':
          this.filteredByData = filteringData.filter(
            (item) => item.mfaStatus === 'NOT_ENROLLED',
          );
          break;
        case 'mfaEnrolled':
          this.filteredByData = filteringData.filter(
            (item) => item.mfaStatus === 'ENROLLED',
          );
          break;
        default:
          this.filteredByData = filteringData.filter(
            (item) => item.groupid === value,
          );
          break;
      }
      // the whole data becomes the filtered data
      if (this.searchTerm) {
        this.filteredData = this.filteredByData.filter((user) => {
          if (
            Object.keys(user).some((key) => `${user[key]}`
              .toLowerCase()
              .includes(this.searchTerm.toLowerCase()))
          ) {
            return user;
          }
          return null;
        });
        this.currentPageNum = 0;
        this.data = await this.filteredData;
        this.tableData = this.data.slice(this.currentPageNum, this.rowsPerPage);
        this.totalCount = this.data.length;
      } else {
        this.data = this.filteredByData;
        this.tableData = this.data.slice(this.currentPageNum, this.rowsPerPage);
        this.totalCount = this.data.length;
      }
      this.selectAll = false;
      this.indeterminateSelectAll = false;
    },

    async handleActionChangePassword() {
      this.handleEvent('Handle action change password');
      this.selectedIds = [];
      const itemIds = this.data.filter((item) => item.selected === true);
      itemIds.forEach((itemId) => {
        this.selectedIds.push(itemId.id);
      });
      await this.handlePasswordChange(this.selectedIds);
      this.resetActionKey();
    },

    async handleActionSuspend() {
      this.handleEvent('Handle action suspend');
      this.selectedIds = [];
      const itemIds = this.data.filter((item) => item.selected === true);
      itemIds.forEach((itemId) => {
        this.selectedIds.push(itemId.id);
      });
      await this.handleSuspend(this.selectedIds);
      this.resetActionKey();
    },

    async handleActionUnlock() {
      this.handleEvent('Handle action unlock');
      this.selectedIds = [];
      const itemIds = this.data.filter((item) => item.selected === true);
      itemIds.forEach((itemId) => {
        this.selectedIds.push(itemId.id);
      });
      await this.handleUnlock(this.selectedIds);
      this.resetActionKey();
    },

    async handleEmailResend() {
      this.handleEvent('Handle action email resend');
      this.selectedIds = [];
      const itemIds = this.data.filter((item) => item.selected === true);
      itemIds.forEach((itemId) => {
        this.selectedIds.push(itemId.id);
      });
      await this.sendSelectedUsersEmailContinue(this.selectedIds);
      this.resetActionKey();
    },

    handleEvent(text) {
      EventHelper.triggerButtonClicked({
        [description]: `Click ${text} action on investigation page`,
        [displayLogic]: 'Visible if investigation has actions',
        [location]: 'Investigation Page',
        [section]: 'Investigative Pages for Widgets',
        [textEventProp]: text,
      });
    },

    async handleSuggestionUpdate() {
      this.handleEvent('Handle action suggestion update');
      this.selectedId = [];
      this.isListLoading = true;
      const itemIds = this.data.filter((item) => item.selected);
      if (itemIds.length > 0) {
        try {
          // eslint-disable-next-line no-restricted-syntax
          for await (const itemId of itemIds) {
            await UserGroupApi.acceptSuggestions(itemId.groupid, {
              user_ids: [itemId.userid],
            });
            /**
             * Remove from the array
             */
            const index = this.origData.findIndex(x => x.id === itemId.id);
            await this.origData.splice(index, 1);
            await this.data.splice(this.data.indexOf(itemId), 1);
            if (this.tableData.length === 1) {
              this.tableData = [];
            } else {
              await this.tableData.splice(this.tableData.findIndex(x => x.id === itemId.id), 1);
            }
            const obj = this.origData.find((o) => o.groupid === itemId.groupid);
            if (!obj) {
              this.selectOptions.splice(this.selectOptions.findIndex(item => Object.values(item)
                .includes(this.filterValue) && this.filterValue !== 'all'), 1);
              this.filterValue = 'all';
              this.data = this.origData;
            }
          }
          this.selectAll = false;
          this.totalCount = this.data.length;
          notify('success', 'User group suggestions updated');
          let start = this.currentPageNum * this.rowsPerPage;
          let end = start + this.rowsPerPage;
          if (!this.tableData.length) {
            if (this.data.length) {
              start = (this.currentPageNum) * this.rowsPerPage;
              end = start + this.rowsPerPage;
              this.tableData = this.data.slice(start, end);
            } else {
              this.currentPageNum = 0;
            }
          } else {
            this.tableData = this.data.slice(start, end);
          }
        } catch (err) {
          notify('error', 'Error updating user group suggestions');
        } finally {
          this.isListLoading = false;
        }
      } else {
        notify('error', 'Data not selected');
      }
    },

    async manageDataState(apiData) {
      // This condition is added to ensure the state of select is maintained during search
      if (this.data.length > 0) {
        const mergedData = Object.values(
          apiData.concat(this.data).reduce(
            (r, o) => ({
              ...r,
              [o.id]: o,
            }),
            {},
          ),
        );
        this.data = mergedData;
        const obj = this.data.filter((o) => o.selected === true);
        if (obj.length !== this.data.length && this.selectAll) {
          this.selectAll = false;
          this.indeterminateSelectAll = true;
        } else if (obj.length === this.data.length && this.selectAll) {
          this.selectAll = true;
          this.indeterminateSelectAll = false;
        } else if (obj.length === 0) {
          this.selectAll = false;
          this.indeterminateSelectAll = false;
        }
      } else {
        this.data = apiData;
      }
      this.handleSortColumn();
      let start = this.currentPageNum * this.rowsPerPage;
      let end = start + this.rowsPerPage;
      if (!this.tableData.length) {
        if (this.data.length) {
          start = (this.currentPageNum - 1) * this.rowsPerPage;
          end = start + this.rowsPerPage;
          this.currentPageNum -= 1;
          this.tableData = this.data.slice(start, end);
        } else {
          this.currentPageNum = 0;
        }
      }
      this.totalCount = this.data.length;
      this.origData = this.data;
      this.isListLoading = true;
    },
  },
};
</script>
<style module>
.container {
  background-color: var(--jc-color-disabled);
  display: inherit;
  height: 100%;
  padding: var(--jc-spacer-x-small);
}

.innerContainer {
  background-color: var(--jc-color-surface-light);
  margin-top: var(--jc-spacer);
  width: 100%;
}

.headerStyle {
  display: flex;
  width: 90%;
}

.list {
  padding-left: var(--jc-spacer);
}

.colorWarning {
  color: var(--jc-color-warning-strong);
  padding-left: var(--jc-spacer-small);
  padding-top: var(--jc-spacer-x-small);
}

.colorSuccess {
  color: var(--jc-color-success-base);
  padding-left: var(--jc-spacer-small);
  padding-top: var(--jc-spacer-x-small);
}

.colorInfo {
  color: var(--jc-color-informational-base);
  padding-left: var(--jc-spacer-small);
  padding-top: var(--jc-spacer-x-small);
}

.dropdownClass {
  float: right;
}
</style>
